import React, { useEffect, useState } from 'react';
import { TableList, Typography, Autocomplete } from 'seagull';
import { matchSorter } from 'match-sorter';
import { useStore, useStoreActions } from "../../../../store/store-context";
import { selectors } from "../../../../store/state-selectors";
import { MapStatusView } from "../MapStatusView";
import styles from "./MapServicesRow.module.scss";
import { serviceTemplateModel } from "../../../../models";
const notMappedText = 'Not mapped';
export default function MapServicesRow(props) {
  const {
    serviceTemplate,
    qboItems,
    integratedQboItem,
    onChangeMap,
    testid
  } = props;
  const [selectedOption, setSelectedOption] = useState(integratedQboItem || null);
  const [mapStatus, setMapStatus] = useState(getServiceTemplateMapStatus(serviceTemplate));
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  const {
    logBI
  } = useStoreActions();
  useEffect(() => {
    setMapStatus(getServiceTemplateMapStatus(serviceTemplate));
  }, [serviceTemplate]);

  const onQboItemChange = async qboItemToMap => {
    logBI(qboItemToMap ? 12006 : 12007, {
      vendorId,
      userId
    });
    setMapStatus('mapping');
    setSelectedOption(qboItemToMap);

    try {
      await onChangeMap(serviceTemplate, qboItemToMap === null || qboItemToMap === void 0 ? void 0 : qboItemToMap.id);
    } catch (e) {
      setMapStatus('failedToMap');
    }
  };

  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "service-template"
      }, /*#__PURE__*/React.createElement(Typography, {
        skin: serviceTemplateModel.isDeleted(serviceTemplate) ? 'secondary' : 'standard',
        ellipsis: true
      }, "".concat(serviceTemplate.name).concat(serviceTemplateModel.isDeleted(serviceTemplate) ? ' (Archived)' : '')))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "qbo-service",
        className: styles.autocompleteWrapper
      }, /*#__PURE__*/React.createElement(Autocomplete, {
        "data-testid": "qbo-services-modal-autocomplete",
        value: selectedOption,
        options: qboItems,
        onChange: (_, newOption) => onQboItemChange(newOption),
        renderOption: option => {
          const {
            name
          } = option;
          return /*#__PURE__*/React.createElement("div", {
            className: styles.qboItemOption
          }, /*#__PURE__*/React.createElement(Typography, {
            ellipsis: true
          }, name));
        },
        getOptionSelected: (option, value) => option.id == value.id,
        getOptionLabel: option => option.name,
        filterOptions: (options, _ref) => {
          let {
            inputValue
          } = _ref;
          const filteredItems = matchSorter(options, inputValue, {
            keys: ['name']
          });
          return filteredItems;
        },
        noOptionsText: "No QuickBooks services",
        loading: !qboItems,
        textFieldProps: {
          placeholder: notMappedText,
          error: mapStatus == 'failedToMap'
        },
        selectOnFocus: true,
        disableClearable: false,
        multiple: false,
        freeSolo: false
      }))
    }, {
      value: /*#__PURE__*/React.createElement(MapStatusView, {
        mapStatus: mapStatus
      })
    }]
  });
}

const getServiceTemplateMapStatus = serviceTemplate => serviceTemplate.integratedId ? 'mapped' : 'notMapped';